<template lang="html">
	<wizard-screen
		panelClass="omapi-panel__5"
		:completed="5"
		:total="5"
		:navNext="false"
		:showExit="false"
	>
		<h2>{{ siteReady }}</h2>
		<div class="omapi-happy-text">
			Here’s what to do next:
		</div>

		<h3>Join our Community:</h3>
		<div class="omapi-next-social-buttons">

			<a
				href="https://twitter.com/optinmonster"
				rel="noopener"
				target="_blank"
				class="omapi-next-social-button omapi-next-social-button__twitter"
			>
				<img src="../../assets/images/icons/twitter.svg" alt="Twitter Logo"/>
				Follow on Twitter
			</a>
			<a
				href="https://www.facebook.com/optinmonster/"
				rel="noopener"
				target="_blank"
				class="omapi-next-social-button omapi-next-social-button__facebook"
			>
				<img src="../../assets/images/icons/facebook.svg" alt="Facebook Logo"/>
				Join on Facebook
			</a>
			<a
				href="https://www.youtube.com/user/optinmonster"
				rel="noopener"
				target="_blank"
				class="omapi-next-social-button omapi-next-social-button__youtube"
			>
				<img src="../../assets/images/icons/youtube.svg" alt="Youtube Logo"/>
				Follow on Youtube
			</a>
		</div>
		<div class="omapi-next-link">
			<a
				:href="$urls.marketing('demo/?utm_source=WordPress&utm_medium=WizardComplete&utm_campaign=Plugin')"
				rel="noopener"
				target="_blank"
			>
				<img src="../../assets/images/icons/open-book.svg" alt="OptinMonster Guide"/>
				Register for a LIVE Demo
			</a>
		</div>
		<div class="omapi-next-link">
			<a
				:href="$urls.docs('optinmonster-builder-overview/?utm_source=WordPress&utm_medium=WizardComplete&utm_campaign=Plugin')"
				rel="noopener"
				target="_blank"
			>
				<img src="../../assets/images/icons/play-icon.svg" alt="Youtube Logo" />
				Get A Quick Tour Of The OptinMonster Campaign Builder
			</a>
		</div>

		<template v-slot:footer>
			<div class="omapi-card-footer">
				<core-button
					@click="exit({ name: 'dashboard' })"
				>
					Visit OptinMonster Dashboard
				</core-button>
				<core-button
					@click="exit({ name: 'settings-tab', params: { selectedTab: 'general' }})"
				>
					See Advanced Settings
				</core-button>
				<core-button
					color="blue"
					@click="exit({ name: 'templates' })"
				>
					Create Your First Campaign
				</core-button>
			</div>
		</template>

	</wizard-screen>
</template>

<script lang="js">
import lowerFirst from 'lodash/lowerFirst'
import { mapGetters, mapActions } from 'vuex'

export default {
	computed : {
		...mapGetters('wizard', [ 'goalDescription' ]),
		siteReady () {
			const desc = this.goalDescription
			let text = 'Your Site is Now Ready to '

			text += desc
				? lowerFirst(desc) + '.'
				: 'go!'

			return text
		},
	},
	methods : {
		...mapActions('wizard', [ 'exit' ]),
	},
}
</script>

<style scoped lang="scss">
	@import '../assets/scss/variables';
	.omapi-screen {
		.omapi-panel__5 {
			.omapi-next-link a:hover {
				color: $color_blue-primary;
				text-decoration: none;
			}
		}
	}
	.omapi-next-link img {
		display: inline-block;
		margin-right: 16px;
	}
	.omapi-panel__5 {
		.omapi-card-footer {
			justify-content: center;
			@media screen and (max-width: 815px) {
				flex-direction: column;
			}

			.omapi-button {
				font-size: 16px;
				font-weight: bold;
				margin-right: 10px;
				padding: 16px 24px;
				@media screen and (max-width: 815px) {
					margin: 0 0 10px;
				}

				&:not(.omapi-button__blue):not(:hover) {
					color: $color_black;
				}
				&.omapi-button__blue {
					margin-right: 0px;
				}
			}
		}
	}
	.omapi-next-social-buttons img {
		margin-right: 5px;
	}
</style>
